import { memo } from 'react';
import styled from 'styled-components';

const StopListIndicator = () => (
  <Wrapper>
    STOP ЛИСТ
  </Wrapper>
);

const Wrapper = styled.span`
    color: #FF6961;
    border: 1px #FF6961 solid;
    border-radius: 4px;
    padding: 2px 5px;
    font-size: 11px;
    margin-left: 8px;
`;

export default memo(StopListIndicator);
